import { render, staticRenderFns } from "./listSuperAdmin.vue?vue&type=template&id=64085acb"
import script from "./listSuperAdmin.vue?vue&type=script&lang=js"
export * from "./listSuperAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports